/**
 * This is a model representing a newly uploaded file on a form, which should be saved along with the form instance.
 */
import Model from "common/framework/Model";
export default Model.define({
    id: "formTempUploadId",
    fields: {

        // ID of the file upload form control
        formControlId: {
            type: "string"
        },

        // ID of the temp file that the server gave us after upload was completed
        formTempUploadId: {
            type: "string"
        },

        fileUid: {
            type: "string",
            transient: true
        }
    }
});